import { supabase } from '../lib/supabase';

// Get API URL from environment variable
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * Make an authenticated API call to your backend
 */
export const makeApiCall = async (endpoint, data, method = 'POST') => {
  try {
    // Get the current session
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;
    
    const headers = {
      'Content-Type': 'application/json',
    };
    
    // Add the authorization header if a token exists
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    // Prepare request options
    const options = {
      method,
      headers,
    };
    
    // Add body for non-GET requests
    if (method !== 'GET' && data) {
      options.body = JSON.stringify(data);
    }
    
    console.log(`Making ${method} request to ${API_URL}${endpoint}`);
    
    // Make the request
    const response = await fetch(`${API_URL}${endpoint}`, options);
    
    // Parse JSON response
    const result = await response.json();
    
    // Check for API errors
    if (!response.ok) {
      throw new Error(result.error || `API error: ${response.status}`);
    }
    
    return result;
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

// Convenience functions
export const apiGet = async (endpoint) => makeApiCall(endpoint, null, 'GET');
export const apiPost = async (endpoint, data) => {
  console.log(`Making POST request to ${API_URL}${endpoint}`);
  
  try {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    
    if (response.status === 429) {
      throw new Error('429 Too Many Requests - Rate limit exceeded');
    }
    
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};